import { Checkbox } from '@mui/material';
import classes from './index.module.css';

const CONFIRM_TEXT = 'I certify that any information I submit is truthful and accurate';

export const ConfirmCheck = ({ checked, onChange }) => (
  <section className={classes.confirm_check}>
    <Checkbox
      checked={checked}
      onChange={onChange}
      color="input"
      style={{ padding: '0px' }}
    />
    <section className={classes.confirm_text}>{CONFIRM_TEXT}</section>
  </section>
);
